export default {"src":"/_next/static/media/section_ressources_1.a89df297.svg","height":50000,"width":5000};